import { Fragment, FunctionComponent, h } from 'preact'
import { RoutableProps } from 'preact-router'

export const Rule: FunctionComponent<RoutableProps> = () => {
  return <Fragment>工事中</Fragment>
}
